import { createStyles, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles, Theme } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import MenuIcon from '@material-ui/icons/Menu';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import Logo from '../../components/img/logo.png';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuButton: {
            marginRight: theme.spacing(2),
        },
        list: {
            minWidth: 230,
        },
        fullList: {
            minWidth: 230,
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
    }),
);
interface userMenu {
    id: string;
    applicationId: string;
    parentMenuId: string;
    name: string;
    url: string;
    target: string;
    icon: string;
    subMenu: [
        {
            id: string;
            applicationId: string;
            parentMenuId: string;
            name: string;
            url: string;
            target: string;
            icon: string;
        }
    ];
}

export default function MenuDrawer() {
    const classes = useStyles();
    const [state, setState] = React.useState(false);
    const [User, setUser] = React.useState("");
    const { user, signOut } = useAuth();
    const [open, setOpen] = React.useState(0);
    const [menuId, setMenuId] = React.useState([]);
    const history = useHistory();

    useEffect(() => {
        if (user && user.email) {
            setUser(`${user.name} (${user.userName})`);
        }
    }, [user]);

    useEffect(() => {
        if (history.location.pathname === '/Blank')
            setState(true);
    }, [history.location.pathname]);

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }
        setState(open);
    };

    function openMenu(item: number) {
        let menuAberto = menuId;
        if (menuAberto.find(i => i === item)) {
            menuAberto.splice(menuAberto.indexOf(item as never), 1);
        } else {
            menuAberto.push(item as never);
        }

        setOpen(menuAberto.length);

        setMenuId(menuAberto);
    }



    function Row(item: userMenu, index: number) {

        return (
            <List
                component="nav"
                aria-labelledby="nested-list-subheader">

                {item.subMenu ?
                    <ListItemButton onClick={() => openMenu(+item.id)}>
                        <ListItemIcon >
                            <Icon>{item.icon}</Icon>
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                        {item.subMenu !== null ? (open > 0 && (menuId.includes(item.id as never))) ? <ExpandLess /> : <ExpandMore /> : <></>}
                    </ListItemButton>
                    :
                    <ListItem button component={Link} to={!item.subMenu ? item.url : ''} key={item.id} onClick={() => setState(false)}>
                        <ListItemIcon >
                            <Icon>{item.icon}</Icon>
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                    </ListItem>
                }

                {item.subMenu !== null ?
                    item.subMenu.map((itemSubMenu: any, submenuIndex: number) =>
                        <Collapse in={open > 0 && (menuId.includes(item.id as never))} timeout="auto" unmountOnExit key={submenuIndex}>
                            <ListItem button component={Link} to={itemSubMenu.url} key={itemSubMenu.id} onClick={() => setState(false)}>
                                <ListItemIcon >
                                    {/* <Icon>{item.icon}</Icon> */}
                                </ListItemIcon>
                                <ListItemText primary={itemSubMenu.name} />
                            </ListItem>
                        </Collapse>
                    )
                    :
                    <></>
                }
            </List>

        )
    }

    const sideList = () => (
        <div
            className={classes.list}
            role="presentation"
            //onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <List>
                <ListItem alignItems='center'>
                    <img src={Logo} alt="" style={{ marginLeft: 30, cursor: 'pointer' }} onClick={() => { setState(false); }} />
                </ListItem>

                <ListItem>
                    <ListItemIcon>
                        <Icon>account_circle</Icon>
                    </ListItemIcon>
                    <ListItemText primary={User} />
                </ListItem>
                {
                    user ?
                        user.userMenu.map((item: userMenu, index: number) => (
                            //Row(item, index)
                            <div key={index}>{Row(item, index)}</div>

                            // <ListItem button component={Link} to={item.url} key={index}>
                            //     <ListItemIcon >
                            //         <Icon>{item.icon}</Icon>
                            //     </ListItemIcon>
                            //     <ListItemText primary={item.name} />
                            // </ListItem>
                        ))
                        :
                        <></>
                }
            </List>
            <Divider />
            <ListItem button onClick={() => { setState(false); signOut(); }} >
                <ListItemIcon>
                    <Icon>login</Icon>
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItem>
        </div>
    );

    return (
        <div>
            <>
                <IconButton
                    edge="start"
                    className={classes.menuButton}
                    color="primary"
                    aria-label="open drawer"
                    onClick={toggleDrawer(true)}
                >
                    <MenuIcon />
                </IconButton>
                <Drawer open={state} onClose={toggleDrawer(false)}>
                    {sideList()}
                </Drawer>
            </>
        </div>
    );
}